import Spinner from 'src/javascripts/components/utilities/Spinner';
import NavQuestionnaire from 'src/javascripts/components/nav/NavQuestionnaire';
import GridNav from 'src/javascripts/components/questionnaires/GridNav';
import ToastCustom from 'src/javascripts/components/alerts/ToastCustom';

export default class QuestionnairesCollectionModulesGrid {

  constructor() {}

  render() {
    const accountUrl = $('body').attr('data-account-url');
    const responseId = $('.polling-indicator').attr('data-response-id');

    // Track last activity time to stop polling if user is idle for a long time
    let lastActivityTime = Date.now();
    let pollActive = false;
    let pollId = null;

    // Functions used to navigate around the page
    GridNav();

    // Add border to navbar on scroll
    NavQuestionnaire();

    // Disable non-changed fields before submit, so only processing new data
    let removeNonChangedFields = function() {
      $('.data-collection-content input:not(:focus):not([disabled]), .data-collection-content select:not(:focus):not([disabled]), .data-collection-content textarea:not(:focus):not([disabled])').attr('disabled', true).addClass('temp');
      $('input.new-data[value=true]').each(function() {
        $(this).closest('tr').find('input, select, textarea').attr('disabled', false);
      })
    }

    // Enable non-changed fields; used after submit
    // Only re-enable fields that were temporarily disabled (marked with .temp), not originally-disabled fields
    let enableNonChangedFields = function() {
      $('.data-collection-content input.temp, .data-collection-content select.temp, .data-collection-content textarea.temp').attr('disabled', false).removeClass('temp');
    }  

    // Start import status poll if importing
    let importPoll = () => {

      // Get generating message on page
      let isGenerating = $('.generating-message');

      // Only continue if status indicator present (if should poll for recs is true)
      if (isGenerating.length !== 0) {

        // Set Api url to get data
        let url = '/' + accountUrl + '/data-collection/responses/' + responseId + '/imports/check_import_status.js?';

        // Execute ajax request (using js erb template to render content so can control profile styling more easily)
        // Must specify '.js' otherwise processes as JSON
        $.ajax({
          type: "POST",
          dataType: "script",
          timeout: 3000,
          url: url,
          complete() {
            setTimeout(function() { importPoll() }, 4000);
          }
        });
      }
    };

    // Poll server for status of mapped items, if generating message present
    if ($('.generating-message').length !== 0) { importPoll(); }

    // Update lastActivityTime on user activity and restart poll if needed
    ['mousemove', 'keydown', 'scroll', 'mousedown', 'touchstart'].forEach(event => {
      document.addEventListener(event, () => {
        lastActivityTime = Date.now();
        // If poll is not active and user is not idle, restart it
        let questionnaireStatus = $('.polling-indicator').attr('data-status');
        if (!pollActive && (questionnaireStatus !== 'approved') && (questionnaireStatus !== 'pending_approval')) {
          pollId = 1 + Math.floor(Math.random() * 1000000);
          pollId = pollId.toString();
          $('.polling-indicator').attr("data-saving-poll", pollId);
          pollActive = true;
          setTimeout(function() { timedSavePoll(pollId) }, 10000);
        }
      }, true);
    });

    // Timed save
    let timedSavePoll = (pollId) => {

      // Check idle time
      let lapsedTime = Date.now() - lastActivityTime;
      if (lapsedTime >= 20000) { // 1 minute
        pollActive = false;
        return; // User is idle, do not run poll
      }
      pollActive = true;

      // Get polling indicator on page
      let savingPoll = $('.polling-indicator').attr("data-saving-poll");
      let status = $('.polling-indicator').attr('data-status');

      // Only continue if status indicator present (if should poll for recs is true)
      if ((savingPoll === pollId) && (status != "approved") && (status != "pending_approval")) {

        // Check if any values changed      
        let valChanged = $('.response-card-body[data-val-changed=\'true\']');

        // Remove non-changed fields
        removeNonChangedFields();

        // Submit form data
        let url = "/" + accountUrl + "/data-collection/responses/" + responseId + '/save';
        $.ajax({
          type: "PATCH",
          data: $("#save_response_form").serialize(),
          timeout: 4000,
          url: url,
          complete(result) { 
            setTimeout(function() { timedSavePoll(pollId) }, 4000);

            // Re-enable disabled fields
            enableNonChangedFields();

            // Set Api url to get data
            let accountUrl = $('body').attr('data-account-url');
            let params = {};
            let url = '/' + accountUrl + '/data-collection/responses/' + responseId + '/poll.js?' + $.param(params);

            // Unhide polling spinner
            $('.polling-indicator').find('.spinner-border').removeClass('d-none');

            // Execute ajax request (using js erb template to render content so can control profile styling more easily)
            // Must specify '.js' otherwise processes as JSON
            $.ajax({
              type: "POST",
              timeout: 10000,
              url: url
            });

          }
        });
      }
    };

    // Poll server for status of mapped items, if generating message present
    let questionnaireStatus = $('.polling-indicator').attr('data-status');
    if ((questionnaireStatus !== 'approved') && (questionnaireStatus !== 'pending_approval')) {
      pollId = 1 + Math.floor(Math.random() * 1000000);
      pollId = pollId.toString();
      $('.polling-indicator').attr("data-saving-poll", pollId);
      pollActive = true;
      setTimeout(function() { timedSavePoll(pollId) }, 10000);
    }

    // Custom methodology ratings
    if ( $('#customMethodologyRatingsList').length !== 0 ) {
      let companyId = $('#customMethodologyRatingsList').attr('data-company-id');
      let url = "/" + accountUrl + "/companies/" + companyId + "/ratings/custom_methodology_scorecard";
      let params = {};
      Spinner($('#customMethodologyRatingsList'));
      $.ajax({
        type: "GET",
        dataType: "script",
        url: url + $.param(params)
      });
    }


  }

}
